import { createContext } from 'react';
import { useFiltersContext } from '../../../Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SAMU, useChartsData } from '../../../../Common/hooks/useChartsData';
import { getUserSession } from '../../../../../../util/core/Session';
import config from '../../../../../../config/config';

export const CallsChartsDataContext = createContext();

const CallsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const session = getUserSession();
    const profile = session?.user?.application_profile_id;
    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const filterParams = {
        ano: filters.ano?.value,
        ...(filters.mes?.value && { mes: filters.mes.value }),
        ...(isAdm && filters.cidade?.value && { city: filters.cidade.value })
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SAMU.CALLS,
            url: 'governanceroom/dashboardsamu/results/calls'
        },
        filterParams
    );
    const chartData = data
        ? {
              callsIndex: data?.callsIndex ?? [],
              callsTimes: data?.callsTimes ?? {},
              callsTimesEvolution: data?.callsTimesEvolution,
              callsTimesMonthlyEvolution: data?.callsTimesMonthlyEvolution

          }
        : {
              callsIndex: [],
              callsTimes: {},
              callsTimesEvolution: [],
              callsTimesMonthlyEvolution: []
          };

    return (
        <CallsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </CallsChartsDataContext.Provider>
    );
};

export default CallsChartsDataProvider;
